export const isAuth = () => localStorage.setItem('accessToken', response.data.access)
export const user = state => state.user
